
import { api } from './api';

export const organisationApi = api.injectEndpoints({
  endpoints: (build) => ({
    getOrganisation: build.query({
      query: (id) => ({
        url: `organisation/${id}`,
      }),
      transformResponse: (response, meta, arg) => {
        return {
          ...response,
          data: {
            ...response.data,
            groups: (response.data.groups || []).map((group) => group.model.ID),
          }
        }
      },
      providesTags: (_result, _err, id) => [{ type: 'Organisations', id }],
    }),
    getLicenceStatistic: build.query({
      query: (id) => ({
        url: `organisation/${id}/get_licence_statistic`,
      }),
      providesTags: (result, _err, id) => [{ type: 'OrgLicence', id: id }],
    }),
    updateOrganisation: build.mutation({
      query: ({id, form}) => ({
        url: `organisation/${id}`,
        method: 'PUT',
        body: JSON.stringify({...form, groups: (form.groups || []).map(group => ({model: {ID: group}}))}),
      }),
      invalidatesTags: (result, error) => {
        return error ? [] : [{ type: 'Organisations', id: 'LIST' }]
      },
    }),
    createOrganisation: build.mutation({
      query: (form) => ({
        url: 'organisation',
        method: 'POST',
        // groups is delivered as a flat list of IDs by the form but the
        // backend expects []models.Group, so wrap each id the same way
        // updateOrganisation already does.
        body: JSON.stringify({
          ...form,
          groups: (form.groups || []).map((group) => ({ model: { ID: group } })),
        }),
      }),
      invalidatesTags: (result, error) => error ? [] : [{ type: 'Organisations', id: 'LIST' }],
    }),
    deleteOrganisation: build.mutation({
      query: (id) => ({
        url: `organisation/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error) => error ? [] : [{ type: 'Organisations', id: 'LIST' }],
    }),
  }),
})

export const {
  useGetOrganisationQuery,
  useLazyGetLicenceStatisticQuery,
  useLazyGetOrganisationQuery,
  useUpdateOrganisationMutation,
  useCreateOrganisationMutation,
  useDeleteOrganisationMutation,
} = organisationApi;

